import Image from 'molecules/Image';
import RichText from 'molecules/RichText';
import ThreeColumnGrid from 'molecules/ThreeColumnGrid';

import styles from 'components/IconCards/iconCards.module.scss';

import type { IconCardsProps } from 'components/IconCards/config';
import type { ElementType, FC } from 'react';

const IconCards: FC<IconCardsProps> = ({ cards, headingTag = 'h3' }) => {
  const HeadingTag = headingTag as ElementType;

  return (
    <div className={styles.cardListThreeUp}>
      <ThreeColumnGrid>
        {cards?.map(item => (
          <div className={styles.card} key={`cardGrid-${item?.title}`}>
            <Image
              width={100}
              height={100}
              className={styles.imgWrapper}
              url={item.media?.url}
              alt={item?.media?.alt || ''}
            />
            {item?.title && <HeadingTag>{item.title}</HeadingTag>}
            {item?.body && <RichText content={item.body} />}
          </div>
        ))}
      </ThreeColumnGrid>
    </div>
  );
};

export default IconCards;
